
// interface JsonViewerProps {
//   data: Record<string, string>;
//   className?: string;
// }

// export default function JsonViewer({ data, className = '' }: JsonViewerProps) {
//   const jsonString = JSON.stringify(data, null, 2);

//   return (
//     <div className={`bg-gray-50 border-2 border-gray-200 rounded-lg p-4 font-mono text-sm ${className}`}>
//       <div className="text-gray-600 mb-2 font-semibold">JSON Schema Preview:</div>
//       <pre className="text-gray-800 whitespace-pre-wrap overfStandard-auto max-h-96">
//         {jsonString}
//       </pre>
//     </div>
//   );
// }


interface JsonViewerProps {
  data: Record<string, string>;
  className?: string;
}

export default function JsonViewer({ data, className = '' }: JsonViewerProps) {
  const jsonString = JSON.stringify(data, null, 2);

  return (
    <div className={`bg-gray-50 border-2 border-gray-200 rounded-lg p-4 font-mono text-sm ${className}`}>
      <div className="text-gray-600 mb-2 font-semibold">JSON Schema Preview:</div>
      <div className="max-h-96 overflow-y-auto border border-gray-300 rounded bg-white p-3">
        <pre className="text-gray-800 whitespace-pre-wrap break-all m-0">
          {jsonString}
        </pre>
      </div>
    </div>
  );
}